 <template>
  <div>
    <section>
    <div class="bg-white">
		 <treeselect
		  v-model="chooseValues"
		  @select="onSelect"
		  @close="onClose"
      @deselect="ondeSelect"
		  :backspaceRemoves="true"
		  :multiple="this.multiple"
		  :required="false"
		  :maxHeight="500"
		  :limit="40"
		  :show-count="true"
      :searchable="true"
		  :clearable="false"
      :limitText="getLimitText"
		  :placeholder="(fromOrder) ? $t('lang.search.criteria'): $t('lang.search.insertsearch')"
		  :alwaysOpen="alwaysopen"
		  :defaultExpandLevel="0"
		  :openDirection="openDirection"
		  :append-to-body="true"
      :load-options="searchOptions"
		  :async="true"
		  :defaultOptions="defaulOptions"
		  :disabled="isDisabled" >
          <label v-if="node.id != ''" slot="option-label" slot-scope="{ node, shouldShowCount, count, labelClassName, countClassName }" :class="labelClassName">
            {{ node.label }}
          </label>
          <small v-else slot="option-label" slot-scope="{ node, shouldShowCount, count, labelClassName, countClassName }" class="text-secondary">
            {{ node.label }}
          </small>
        </treeselect>

     </div>


    </section>
  </div>
</template>
<script>
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import { ASYNC_SEARCH } from '@riophae/vue-treeselect'

const simulateAsyncOperation = fn => {
  setTimeout(fn, 20)
}

export default {
    props: {
        fromOrder: {
	        type: Boolean,
	        required: false,
	        default: false,
      	},
        default_values: {
	        type: Array,
	        required: false,
	        default: () => [],
      	},
        option_list: {
	        type: Array,
	        required: true,
	        default: () => [],
      	},
        alwaysopen: {
	        type: Boolean,
	        required: false,
	        default: () => false,
      	},
        multiple: {
	        type: Boolean,
	        required: false,
	        default: () => true,
      	},
        emptyOption: {
	        type: Boolean,
	        required: false,
	        default: () => false,
      	},
		isDisabled: {
	        type: Boolean,
	        required: false,
	        default: () => false,
      	},
		openDirection: {
	        type: String,
	        required: false,
	        default: () => 'auto',
      	},
    },
    data() {
      return {
      	chooseValues: Array,
      	defaulOptions: Array
       };

    },
    created(){
    	let obj;
	     this.defaulOptions = []
    	if(this.emptyOption){
	      obj = {}
	      obj.label = '<Nothing selected>'
	      obj.id = ''
	      this.defaulOptions.push(obj)
    	}

        this.option_list.forEach((val) => {
        	this.defaulOptions.push(val)
        })

    	this.chooseValues = this.default_values
    },

    components: {
    	'treeselect': Treeselect,
    },

    methods: {
		getLimitText(count){
			return "Recherchez ( "+count+" sélectionnés )";
		},
		getChildren(options){
		  const children = options.map(function(item) {
		    return item.children;
		  });
		  return children.flat();
		},
	    searchOptions({ action, searchQuery, callback }) {
	      if (action === ASYNC_SEARCH) {
	        simulateAsyncOperation(() => {
	          let options = this.defaulOptions.filter(option => option.label.toLowerCase().includes(searchQuery.toLowerCase()));
	          if(options.length == 0){
	            let options = this.getChildren(this.defaulOptions).filter(option => option.label.toLowerCase().includes(searchQuery.toLowerCase()));
	            if(options.length == 0){
	              let options = this.getChildren(this.getChildren(this.defaulOptions)).filter(option => option.label.toLowerCase().includes(searchQuery.toLowerCase()));
	              callback(null, options);
	            }
	            callback(null, options);
	          }
	          callback(null, options)
	        })
	      }
	    },
	    onSelect(node, instanceId){
	    	if(!this.multiple){
	    		this.default_values.splice(0, 1);
	    		this.$emit('deleted',node);
	    	}
	      	this.default_values.push(node.id)

	    	if(!this.multiple && this.emptyOption && node.id == ''){
	    		this.default_values.splice(0, 1);
	    		this.$emit('deleted',node);
	    	}

			this.$emit('selected',node);
	    },
		onClose(node, instanceId){
			if(Array.isArray(node) && node.length != this.default_values.length){
				node.forEach((res) => {
		            this.default_values.push(res)
	          	});
			}
	      	//this.default_values.push(node.id)
			this.$emit('closed',node);
	    },
	    ondeSelect(node, instanceId){
	    	let index = this.default_values.indexOf(node.id)
			this.default_values.splice(index, 1);
			this.$emit('deleted',node);
	        // delete this.default_values[index]
	    },
    }
}

</script>


<style>
.vue-treeselect__multi-value-item-container.vue-treeselect__multi-value-item--transition-enter-to{
   color: white;
    font-weight: bold;

}
.vue-treeselect__multi-value-item{
	border-radius:3px;
	font-size: 10px;
	background-color: #5055ea;
    color: white;
}

.vue-treeselect__icon.vue-treeselect__value-remove{
    border-left: 0;
    color: white;
}
</style>
